module.exports = __webpack_public_path__ + "static/media/cashcollector.bf9f5c0d.png";